import { combineReducers } from 'redux'
import notificationAlert from './NotificationState'
import updateTheme from './ThemeState'

const rootReducer = combineReducers({
  notificationAlert,
  updateTheme,
})

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
